import { ClassModel, register, types } from "@gadgetinc/mobx-quick-tree";
import { DateTime } from "luxon";
import { DynamicTimeRange, FixedTimeRange, LuxonDate } from "./TimeRange";

// The loki stream response format
// https://grafana.com/docs/loki/latest/api/#get-lokiapiv1query_range

export interface LokiStream {
  stream: Record<string, string>; // the labels that uniquely identify the stream
  values: LokiLogTuple[]; // list of (time, message) results
}

//every loki log is an array [timestamp: string, message: string]
export type LokiLogTuple = [string, string];

export interface LogResult {
  resultType: "streams";
  result: LokiStream[];
}

@register
export class QuerySnapshot extends ClassModel({
  createdAt: types.optional(LuxonDate, DateTime.now()),
  logql: types.maybe(types.string),
  timeRange: types.maybe(types.union(DynamicTimeRange, FixedTimeRange)),
}) {}

export function getLogTuplesFromStreams(streams: LokiStream[]): LokiLogTuple[] {
  const tuples = streams.map((stream) => stream.values).flat();
  return tuples;
}
